<template>
  <nav class="bg-white shadow-md sticky top-0 z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <router-link to="/" class="flex items-center">
          <img class="h-10 w-auto" src="../assets/lioedge_logo.jpg" alt="Company Logo">
          <span class="ml-2 text-xl font-bold text-gray-800">LioEdge</span>
        </router-link>
        
        <!-- Desktop menu -->
        <div class="hidden md:flex items-center space-x-4">
          <router-link to="/" class="text-gray-600 hover:text-gray-900">Home</router-link>
          <router-link to="/products" class="text-gray-600 hover:text-gray-900">Products</router-link>
          <router-link to="/partners" class="text-gray-600 hover:text-gray-900">Partners</router-link>
          <router-link to="/about" class="text-gray-600 hover:text-gray-900">About</router-link>
          <router-link to="/contact" class="text-gray-600 hover:text-gray-900">Contact</router-link>
        </div>
        
        <!-- Mobile menu button -->
        <div class="md:hidden flex items-center">
          <button 
            @click="toggleMobileMenu"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 focus:outline-none"
            aria-expanded="false"
          >
            <span class="sr-only">Open main menu</span>
            <svg 
              v-if="!mobileMenuOpen" 
              class="h-6 w-6" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg 
              v-else 
              class="h-6 w-6" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    
    <!-- Mobile menu -->
    <div v-show="mobileMenuOpen" class="md:hidden">
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <router-link 
          v-for="item in menuItems" 
          :key="item.name"
          :to="item.path"
          class="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
          @click="mobileMenuOpen = false"
        >
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'

const mobileMenuOpen = ref(false)

const menuItems = [
  { name: 'Products', path: '/products' },
  { name: 'Partners', path: '/partners' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' }
]

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}
</script>
